import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CLARITY_PROJECT_ID_N2N, ensureClarityLoaded } from '../utils/clarity';

/**
 * Loads Microsoft Clarity only when mounted.
 * Intended to be rendered only on the `/n2n/*` route.
 */
export default function N2NClarity() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/n2n')) return;
    ensureClarityLoaded(CLARITY_PROJECT_ID_N2N);
  }, [location.pathname]);

  return null;
}
